<template>
  <div>
    <b-modal
        :title="$t('Schedule picker')"
        v-model="show"
        dialog-class="trans-modal bg-app"
        :hide-footer="true"
        no-close-on-backdrop>
      <form @submit.prevent="selected()">
        <b-form-group>
          <b-select v-model="formData.scheduleId" class="input-trans calendar">
            <option v-for="(schedule, index) in schedules" :key="index" :value="schedule.ScheduleID">
              {{ schedule.Name }}
            </option>
          </b-select>
        </b-form-group>

        <b-form-group class="mb-0">
          <b-button type="submit" pill size="lg" class="btn-block btn-trans-primary">
            {{
              $t("Enter meeting")
            }}
          </b-button>
        </b-form-group>
      </form>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "StartMeetingSchedulePicker",
  data: function () {
    return {
      show: false,
      schedules: [],
      formData: {
        scheduleId: ""
      }
    }
  },
  methods: {
    open: function (schedules) {
      this.schedules = schedules;
      if (schedules.length > 0)
        this.formData.scheduleId = schedules[0].ScheduleID;

      this.show = true;
    },
    selected: function () {
      this.show = false;
      this.$emit("select", this.schedules.find(x => x.ScheduleID === this.formData.scheduleId));
    }
  }
}
</script>